<template>
	<div class="container-faq">
		<div class="faq-title">{{ getConstants('FAQ') }}</div>
		<div class="faq-content">
			<div class="faq-ct-item" v-for="i in 9" :key="i">
				<p class="faq-ct-title">
					{{ getConstants('PRICING_NEW_FAQ_REQUEST' + i) }}
				</p>
				<p
					class="faq-ct-text"
					v-html="getConstants('PRICING_NEW_FAQ_ANSWER' + i)"
				></p>
			</div>
		</div>
	</div>
</template>
<script>
export default {}
</script>
<style lang="scss" scoped>
.container-faq {
	margin: 0 auto;
	min-width: 720px;
	max-width: 960px;
	padding-bottom: 48px;
	.faq-title {
		padding-top: 60px;
		font-size: 24px;
		line-height: 40px;
	}
	.faq-content {
		.faq-ct-title {
			padding-top: 48px;
			padding-bottom: 24px;
			line-height: 30px;
			font-size: 18px;
		}
		.faq-ct-text {
			font-size: 14px;
			line-height: 24px;
		}
	}
}
</style>
